import { PERMISSIONS, type Permission } from '@zeroth/shared';

/** Choose a visible, authorized landing page for the current membership. */
export function defaultPathForPermissions(granted: Permission[]): string {
  const has = (permission: Permission) => granted.includes(permission);
  if (has(PERMISSIONS.DASHBOARD_VIEW)) return '/dashboard';
  if (has(PERMISSIONS.AI_USE)) return '/agent';
  if (has(PERMISSIONS.SHIPMENTS_VIEW)) return '/workflows/working-shipments';
  if (has(PERMISSIONS.SHIPMENTS_CREATE) || has(PERMISSIONS.SHIPMENTS_MANAGE)) {
    return '/workflows/draft-shipments';
  }
  if (has(PERMISSIONS.SHIPPING_MANAGE)) return '/workflows/shipped/freight';
  if (has(PERMISSIONS.LABELS_PRINT)) return '/workflows/labels';
  if (has(PERMISSIONS.PRODUCTS_VIEW)) return '/products';
  if (has(PERMISSIONS.INVENTORY_VIEW)) return '/inventory/audit';
  if (has(PERMISSIONS.RESTOCK_VIEW)) return '/restock/suggestions';
  if (has(PERMISSIONS.PURCHASE_ORDERS_VIEW)) return '/restock/pos';
  if (has(PERMISSIONS.ANALYTICS_VIEW)) return '/analytics';
  if (has(PERMISSIONS.REPORTS_VIEW)) return '/reports';
  if (has(PERMISSIONS.ACCOUNT_USERS_MANAGE) || has(PERMISSIONS.STORES_SETTINGS_UPDATE)) {
    return '/settings';
  }
  return '/dashboard';
}
